"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adapter_1 = require("@video/video-client-core/lib/api/adapter");
const react_1 = require("react");
const useMediaQuery = (query) => {
    const [matches, setMatches] = (0, react_1.useState)(() => false);
    (0, react_1.useEffect)(() => {
        if (adapter_1.device.isImplements(adapter_1.Feature.MATCH_MEDIA)) {
            const mediaQueryList = adapter_1.device.matchMedia(query);
            const handleMediaQueryChange = (event) => {
                setMatches(event.matches);
            };
            mediaQueryList.addEventListener("change", handleMediaQueryChange);
            // Update the state once at the beginning to ensure it reflects the correct initial state
            setMatches(mediaQueryList.matches);
            // Cleanup: Remove the event listener when the component unmounts
            return () => {
                mediaQueryList.removeEventListener("change", handleMediaQueryChange);
            };
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => { };
    }, [query]);
    return matches;
};
exports.default = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map